import { Controller } from '@hotwired/stimulus';

/**
 * Switches a plan card between its short-term and 12-month variants.
 *
 * Listens for `plan-toggle:change` on document so toggles in the comparison
 * table (same toggleId) stay in sync with membership plan cards above.
 * Only events whose `toggleId` matches this card's configured toggle id
 * (`data-plan-card-toggle-id-value`) are acted upon.
 *
 * Each variant element carries `data-variant="short"|"annual"`; turning the
 * toggle on activates the "annual" variant, off activates "short". This is
 * purely local DOM state — no backend reload. The comparison table's own
 * short/annual benefit cells are swapped independently by compare-plans-controller,
 * which listens for the same event.
 */
export default class extends Controller {
	static get targets () {
		return ['variant'];
	}

	static get values () {
		return {
			toggleId: String,
		};
	}

	connect() {
		this.onToggleChange = this.onToggleChange.bind(this);
		document.addEventListener('plan-toggle:change', this.onToggleChange);
	}

	disconnect() {
		document.removeEventListener('plan-toggle:change', this.onToggleChange);
	}

	onToggleChange(event) {
		if (event.detail.toggleId !== this.toggleIdValue) {
			return;
		}

		const targetVariant = event.detail.checked ? 'annual' : 'short';

		this.variantTargets.forEach((variant) => {
			const isActive = variant.dataset.variant === targetVariant;
			variant.classList.toggle('is-active', isActive);
			variant.hidden = !isActive;
		});
	}
}
